import styled from 'styled-components';

export const ActualMatch = styled.p`
  color: #ffffff;
  font-size: 64px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.02em;
  line-height: 64px;
  margin: 0;
`;
ActualMatch.displayName = 'ActualMatch';

export const Background = styled.svg`
  position: absolute;
  z-index: -1;
`;
Background.displayName = 'Background';

export const Container = styled.section`
  font-family: 'Noto Sans', sans-serif;
  position: relative;
`;
Container.displayName = 'Container';

export const Divider = styled.div`
  height: 81px;
  width: 80px;
`;
Divider.displayName = 'Divider';

export const DataContainer = styled.div`
  align-items: center;
  display: flex;
  height: 81px;
  width: 561px;
`;
DataContainer.displayName = 'DataContainer';

export const MatchData = styled.div`
  align-items: center;
  display: flex;
  overflow: hidden;
  width: 135px;
`;
MatchData.displayName = 'MatchData';

export const MatchIcon = styled.div`
  box-sizing: border-box;
  height: 47px;
  padding: 0 16px;
  width: 105px;
`;
MatchIcon.displayName = 'MatchIcon';

export const Rank = styled.p`
  color: #ffffff;
  font-size: 64px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.02em;
  line-height: 64px;
  margin: 0;
`;
Rank.displayName = 'Rank';

export const RankData = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  overflow: hidden;
  width: 155px;
`;
RankData.displayName = 'RankData';

export const RankIcon = styled.div`
  box-sizing: border-box;
  height: 47px;
  padding: 0 16px;
  width: 78px;
`;
RankIcon.displayName = 'RankIcon';

export const TotalMatch = styled.p`
  color: #ffffff;
  font-size: 32px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.02em;
  line-height: 64px;
  margin: 0;
`;
TotalMatch.displayName = 'TotalMatch';
